$(document).ready(()=>{let t=$("#customModal"),i=$(".close-button"),s=t=>{let i=t.slick("slickCurrentSlide"),s=t.find(`.slick-slide[data-slick-index="${i}"] video`).get(0);s&&(s.muted=!1,s.play().catch(t=>{console.error("Playback error:",t)}))};$(".cstm-video-section-content").slick({slidesToShow:4.3,slidesToScroll:1,infinite:!1,prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>',nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>',responsive:[{breakpoint:991,settings:{slidesToShow:3.2}},{breakpoint:767,settings:{slidesToShow:1.6,centerPadding:"35px"}},]}),$(".videos_wrapper_cstm video").on("click",function(){t.css({display:"block",zIndex:999}),$("body").css("overflow","hidden"),t.attr("aria-hidden","false");let i=$(".videos_wrapper_cstm video").index(this),_=$(".modal-video-section-content");_.hasClass("slick-initialized")||(_.slick({slidesToShow:1,slidesToScroll:1,prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>',nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>'}),_.on("afterChange",(t,i,e)=>{$(".modal_videos_wrapper_cstm video").each(function(){this.pause(),this.currentTime=0,this.muted=!0}),s(_)})),_.slick("slickGoTo",i,!0),setTimeout(()=>s(_),300)}),i.on("click",()=>{t.hide(),$("body").css("overflow",""),t.attr("aria-hidden","true"),$(".modal_videos_wrapper_cstm video").each(function(){this.pause(),this.currentTime=0,this.muted=!0})}),$(window).on("click",s=>{$(s.target).is(t)&&i.trigger("click")}),$(window).width()>768&&$(".enable_slider_desktop").slick({infinite:!0,slidesToShow:5,slidesToScroll:1,prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>',nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>'}),$(".home_switch_cstm_slider").slick({slidesToShow:4.3,slidesToScroll:1,variableWidth:!0,dots:!0,infinite:!1,prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>',nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>',responsive:[{breakpoint:768,settings:{arrows:!1,slidesToShow:2,slidesToScroll:1}},{breakpoint:550,settings:{arrows:!1,slidesToShow:1,slidesToScroll:1}}]})});
$(".custom-review-nav").slick({slidesToShow:3,infinite:!0,slidesToScroll:1,autoplay:!0,autoplaySpeed:3e3,dots:!1,prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"></path><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"></path></svg></button>',nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"></path><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"></path></svg></button>',responsive:[{breakpoint:991,settings:{slidesToShow:2}},{breakpoint:767,settings:{slidesToShow:1}}]});
$(document).ready(function(){
  $('.cstm-marquee').slick({
        dots: false,
        infinite: true,
        speed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: false,
        cssEase: 'linear',
        pauseOnHover: false,
        variableWidth: true,
         responsive: [{
              breakpoint: 768,
              settings: {
                  arrows: false,
                  slidesToShow: 4
              }
          }, {
              breakpoint: 480,
              settings: {
                  arrows: false,
                  slidesToShow: 4,
                infinite: true,
                autoplay: true,
              }
          }]
      });
      $(document).on('click', '.child_drawer_menu_custom', function () {

  const menuDrawer = document.querySelector('#menu-drawer');
  const navigation = document.querySelector('.menu-drawer__navigation');

  $(this)
    .closest('.menu-drawer__inner-container')
    .addClass('cstm_child_new_menu');

  if (menuDrawer) {

    menuDrawer.style.setProperty('overflow-y', 'hidden', 'important');

    if (navigation) {

      const navHeight = navigation.scrollHeight + 280;

      menuDrawer.style.height = navHeight + 'px';
      menuDrawer.style.maxHeight = navHeight + 'px';

    }

  }

});

$(document).on('click', '.back_to_child .back_cstm_wrapper', function () {

  const menuDrawer = document.querySelector('#menu-drawer');

  $(this)
    .closest('.menu-drawer__inner-container')
    .removeClass('cstm_child_new_menu');

  if (menuDrawer) {

    menuDrawer.style.setProperty('overflow-y', 'auto', 'important');

    menuDrawer.style.height = '';
    menuDrawer.style.maxHeight = '';

  }

});

document.querySelectorAll('.menu-mobile_drawer p').forEach(p => {
  p.textContent = p.textContent.replace(/-/g, ' ');
});

});
//  document.querySelector('.sticky-atc.product-form .product-form__buttons .product-form__submit').addEventListener('click',e=>{e.preventDefault();const t=document.querySelector('.product-form .product-form__submit');t?t.click():console.error('Main ATC button not found.')}); 
  $('.upsell_prod_wrap').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,  
  prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"></path><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"></path></svg></button>',
  nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"></path><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"></path></svg></button>'
});
$(document).on("click", ".upsell_prod .upsell_btn", function() {
    var $button = $(this);
    var $spinner = $button.find(".loading__spinner");
    $button.css("opacity", "0.6").prop("disabled", true);
    $spinner.removeClass("hidden").fadeIn(200);

    var cartselector = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    var variant_id = $button.attr("data-var-upsellid");
    var item = {
        id: variant_id,
        quantity: 1,
        sections: cartselector.getSectionsToRender().map((section) => section.id)
    };

    $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: item,
        dataType: "json",
        success: function(resp) {
            $(cartselector).removeClass("is-empty");
            cartselector.getSectionsToRender().map((section) => section.id);
            cartselector.renderContents(resp);
        },
        complete: function() {
            $spinner.fadeOut(200, function() {
                $(this).addClass("hidden");
                $button.css("opacity", "1").prop("disabled", false);
            });
        }
    });

    return false;
});


const stickyBtn = document.querySelector('.sticky-atc.product-form .product-form__buttons .product-form__submit');

if (stickyBtn) {
  const spinner = stickyBtn.querySelector('.loading__spinner');
  const mainBtn = document.querySelector('.product-form .product-form__submit');

  stickyBtn.addEventListener('click', e => {
    e.preventDefault();

    if (!mainBtn) {
      console.error("Main ATC button not found.");
      return;
    }

    // Loader show + button disable
    spinner?.classList.remove('hidden');
    stickyBtn.style.opacity = "0.6";
    stickyBtn.disabled = true;

    // Trigger original ATC
    mainBtn.click();
  });

  // Shopify Pub/Sub event listener
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.log('Cart updated via PUB_SUB_EVENTS:', event);

    // Loader hide + button reset
    spinner?.classList.add('hidden');
    stickyBtn.style.opacity = "1";
    stickyBtn.disabled = false;
  });
}


document.querySelectorAll('.child_coll_list_trigger').forEach(function (trigger) {

  trigger.addEventListener('click', function () {

    const menuType = this.getAttribute('data-menu-type');

    const collectionWrapper = document.querySelector('.collection_list_wrapper');
    const productWrapper = document.querySelector('.product_list_wrapper');

    if(menuType == 'collection'){

      collectionWrapper.style.display = 'grid';
      productWrapper.style.display = 'none';

    }else{

      collectionWrapper.style.display = 'none';
      productWrapper.style.display = 'grid';

    }

  });

});


$(document).ready(function() {
  if ($('.partner-grid').hasClass('slick-initialized')) {
    $('.partner-grid').slick('unslick');
  }
  $('.partner-grid').each(function() {
    $(this).slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500,
      slidesToShow: 8,
      variableWidth: true,
      slidesToScroll: 1,
      prevArrow:'<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"></path><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"></path></svg></button>',
      nextArrow:'<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"></path><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"></path></svg></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
      ]
    });
  });


});